import React, { useState } from "react";
import style from "css/template.module.css";
import { useNavigate } from "react-router-dom";
import { Menu } from "antd";

function SideMenu(props) {
  //navigate
  const navigate = useNavigate();
  const menuHandler = (e) => {
    props.close();
    console.log(e.type);

    navigate(process.env.REACT_APP_CLIENT_URL + e.key, {
      state: {
        title: e.type,
      },
    });
  };
  const menuList = [
    {
      label: "CAD/CAM",
      key: "CAD",
      children: [
        { label: "ZWCAD 2025", key: "CAD", type: 1 },
        { label: "AutoCAD", key: "CAD", type: 2 },
        { label: "ZW3D 2025", key: "CAD", type: 3 },
      ],
    },
    {
      label: "Microsoft",
      key: "Microsoft",
      children: [
        { label: "Windows 11 Pro", key: "Microsoft", type: 1 },
        { label: "Office", key: "Microsoft", type: 2 },
        { label: "Microsoft 365", key: "Microsoft", type: 3 },
      ],
    },
    {
      label: "Adobe",
      key: "Adobe",
      children: [
        { label: "Creative Cloud", key: "Adobe", type: 1 },
        { label: "Photoshop/Illustrator", key: "Adobe", type: 2 },
        { label: "Acrobat Pro", key: "Adobe", type: 3 },
      ],
    },
    {
      label: "랜더링",
      key: "Landering",
      children: [
        { label: "KeyShot", key: "Landering", type: 1 },
        { label: "Rhinoceros", key: "Landering", type: 2 },
        { label: "Lumion", key: "Landering", type: 3 },
      ],
    },
    {
      label: "문서/자산관리",
      key: "Documents",
      children: [
        { label: "Foxit PDF Editor", key: "Documents", type: 1 },
        { label: "Office HWP(한글)", key: "Documents", type: 2 },
        { label: "넷클라이언트", key: "Documents", type: 3 },
      ],
    },
    {
      label: "보안 솔루션",
      key: "Security",
      children: [
        { label: "AhnLab V3", key: "Security", type: 1 },
        {
          label: "Bitdefender GravityZone Business Security",
          key: "Security",
          type: 2,
        },
        {
          label: "Bitdefender GravityZone Business Security Enterprise",
          key: "Security",
          type: 3,
        },
      ],
    },
    {
      label: "고객센터",
      key: "Customer",
      children: [
        { label: "공지사항", key: "Announcement" },
        // { label: "방문지원", key: "onsite_support" },
        { label: "이벤트", key: "Event" },
        { label: "무료체험", key: "Free" },
        { label: "견적요청", key: "Request" },
      ],
    },
  ];

  const [openMenu, setOpenMenu] = useState("");
  const handleOpenMenu = (e) => {
    setOpenMenu(e);
  };

  return (
    <div className={style.sidemenu_wrapper}>
      <div className={style.sidemenu_area}>
        {menuList.map((menu, index) => (
          <div
            key={index}
            className={
              openMenu === menu.key
                ? `${style.sidemenu_item_active} cursor`
                : `${style.sidemenu_item} cursor`
            }
            onClick={() =>
              handleOpenMenu(openMenu === menu.key ? "" : menu.key)
            }
          >
            <div className={style.sidemenu_item_title}>
              <div className={style.sidemenu_item_label}>{menu.label}</div>
              <div className={style.sidemenu_item_arrow}>
                <img
                  alt=""
                  src={
                    openMenu === menu.key
                      ? "/img/common/menu_arrowb.png"
                      : "/img/common/menu_arrow.png"
                  }
                />
              </div>
            </div>
            {openMenu === menu.key ? (
              <div className={style.sidemenu_submenu_list}>
                {menu.children.map((submenu, idx) => (
                  <div
                    key={idx}
                    className={style.sidemenu_submenu_item}
                    onClick={() => menuHandler(submenu)}
                  >
                    {submenu.label}
                  </div>
                ))}
              </div>
            ) : (
              <></>
            )}
          </div>
        ))}
      </div>
      <div className={style.sidemenu_footer}>
        <div
          className={style.sidemenu_footer_btn}
          onClick={() => menuHandler({ key: "free" })}
        >
          무료체험
        </div>
        <span></span>
        <div
          className={style.sidemenu_footer_btn}
          onClick={() => menuHandler({ key: "request" })}
        >
          견적 신청
        </div>
      </div>
    </div>
  );
}

export default SideMenu;
